export const toolGradiant = `<svg xmlns="http://www.w3.org/2000/svg" width="17" height="16" viewBox="0 0 17 16" fill="none">
<path fill-rule="evenodd" clip-rule="evenodd" d="M16.1841 4.24489C16.8997 6.40183 16.3997 8.8737 14.6833 10.5901C13.044 12.2294 10.7158 12.7591 8.63081 12.1801L4.9871 15.8238C4.75213 16.0587 4.3688 16.0587 4.1338 15.8238L0.676225 12.3662C0.441258 12.1312 0.441258 11.7479 0.676225 11.5129L4.31993 7.86916C3.74086 5.78423 4.27063 3.45592 5.9099 1.81669C7.62631 0.100286 10.0981 -0.399681 12.2551 0.315953L8.25024 4.32083L9.08054 7.4195L12.1792 8.24976L16.1841 4.24489Z" fill="url(#paint0_linear_2775_499)"/>
<defs>
<linearGradient id="paint0_linear_2775_499" x1="0.5" y1="3" x2="16.5" y2="16" gradientUnits="userSpaceOnUse">
<stop stop-color="#FF53FF"/>
<stop offset="1" stop-color="#00DBFF"/>
</linearGradient>
</defs>
</svg>`;
